import {EOL} from "os";
import Prism from "prismjs";
import pureCode from "./pure-code";

// const map = {
//   xml: 'markup',
//   html: 'markup',
//   mathml: 'markup',
//   svg: 'markup',
//   js: 'javascript',
//   md: 'markdown',
//   yml: 'yaml',
//   rb: 'ruby',
//   shell: 'bash',
//   py: 'python',
//   dotnet: 'csharp',
//   coffee: 'coffeescript',
// }

const code = class {
  private lineNumbers: boolean;

  constructor(config: { lineNumbers: boolean }) {
    this.lineNumbers = config.lineNumbers;
  }

  code(block: string, lang: string, lineNumbers = this.lineNumbers):string {
    let code;

    if (!lang) {
      code = pureCode(block);
    } else {
      const grammar = Prism.languages[lang];

      code = grammar
        ? `<pre class="language-${lang}"><code class="language-${lang}">${Prism.highlight(
          block,
          grammar,
          lang
        )}</code></pre>`
        : pureCode(block);
    }

    const line = `<pre class="language-none"><code class="language-none">${block
      .split(EOL)
      .map((n, i) => `<span>${i + 1}</span>\n`)
      .join("")}</code></pre>`;

    const codeWidthLines = `<div class="code-highlight">
  <table>
    <tbody>
      <tr>
        <td class="code-highlight-line">${line}</td>
        <td class="code-highlight-code">${code}</td>
      </tr>
    </tbody>
  </table>
</div>`;

    if (lineNumbers) {
      return codeWidthLines;
    } else {
      return code;
    }
  }
};
export default code;
